import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { DeprecatedLinkButton } from '../../primitives/deprecated-buttons/deprecated-link-button/link-button';
import { Popover } from '../../primitives/popover/popover';
import { DeprecatedPositiveButton, DeprecatedHollowButton } from '../../primitives/deprecated-buttons/deprecated-button/button';
import { DeprecatedText } from '../../deprecated-typography';
import { Text } from '../../new-libby/core/typography/index';
import { DeprecatedSelect } from '../../primitives/selectors';
var PhoneNumberView = /** @class */ (function (_super) {
    __extends(PhoneNumberView, _super);
    function PhoneNumberView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedLineId: _this.props.lines && _this.props.lines.length ? _this.props.lines[0].id : null,
            isPopoverOpen: false,
            isFocused: false,
        };
        _this.tp = function (key, params) { return _this.props.t("common.phone-number-view." + key, params); };
        _this.onLineSelected = function (selectedLine) {
            _this.setState({ selectedLineId: selectedLine.value });
        };
        _this.toggleFocus = function (isFocused) { return function () { return _this.setState({ isFocused: isFocused }); }; };
        return _this;
    }
    PhoneNumberView.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.state.selectedLineId && nextProps.lines && nextProps.lines.length) {
            this.setState({ selectedLineId: nextProps.lines[0].id });
        }
    };
    PhoneNumberView.prototype.onPhoneNumberClick = function () {
        this.setState({ isPopoverOpen: !this.state.isPopoverOpen });
    };
    PhoneNumberView.prototype.closePopover = function () {
        if (!this.state.isFocused) {
            this.setState({ isPopoverOpen: false });
        }
    };
    PhoneNumberView.prototype.onCallClick = function (callData) {
        this.closePopover();
        if (this.props.onCall) {
            this.props.onCall(callData);
        }
    };
    PhoneNumberView.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var phoneNumber = this.props.phoneNumber;
        var renderLabel = function (line) {
            return (React.createElement("div", { className: 'options-label' },
                React.createElement("span", { className: 'line-name' }, line.name),
                " ",
                React.createElement("span", { className: 'line-number' },
                    "(",
                    line.phoneNumber,
                    ")")));
        };
        var options = props.lines ? props.lines.map(function (line) { return ({
            value: line.id,
            label: renderLabel(line)
        }); }) : [];
        var callData = { phoneNumber: phoneNumber, lineId: this.state.selectedLineId };
        var phoneNumberString = "+" + phoneNumber.countryCode + "-" + phoneNumber.number;
        var isDisabled = !this.props.onCall;
        var classNames = namespacedClassnames('phone-number-view', {
            disabled: isDisabled
        });
        var handlePhoneNumberClick = function () { return _this.onPhoneNumberClick(); };
        var handleClosePopover = function () { return _this.closePopover(); };
        var handleCallClick = function () { return _this.onCallClick(callData); };
        var hasMultipleLines = props.lines && props.lines.length > 1 || false;
        var hasLines = props.lines && props.lines.length > 0 || false;
        var lineSelector = (React.createElement(DeprecatedSelect, { className: 'phone-selector', value: this.state.selectedLineId, options: options, placeholder: 'Select Option', onChange: this.onLineSelected, onFocus: this.toggleFocus(true), onBlur: this.toggleFocus(false) }));
        var callTitle = function (multipleLines) {
            return multipleLines
                ? _this.tp('multiple-line.title')
                : _this.tp('single-line.title');
        };
        var callActionsBody = (React.createElement("div", { className: 'call-actions-body' },
            React.createElement(DeprecatedText, { className: 'phone-title', type: 'h2' }, callTitle(hasMultipleLines)),
            hasMultipleLines && lineSelector,
            React.createElement("div", { className: 'call-actions' },
                React.createElement(DeprecatedHollowButton, { onClick: handleClosePopover }, this.tp('call-cancel')),
                React.createElement(DeprecatedPositiveButton, { disabled: !hasLines ? this.tp('call-disabled') : false, onClick: handleCallClick }, this.tp('call-now')))));
        var isPopoverOpen = this.state.isPopoverOpen;
        var phoneAsTextOrButton = isDisabled ? (React.createElement(Text, { type: 'hxs', color: 't30', className: 'phone-number', ellipsis: true }, phoneNumberString)) : (React.createElement(DeprecatedLinkButton, { className: 'phone-number', onClick: handlePhoneNumberClick },
            React.createElement(Text, { type: 'hxs', color: 't30', className: 'phone-number', ellipsis: true }, phoneNumberString)));
        return (React.createElement("div", { className: classNames },
            React.createElement(Popover, { isOpen: isPopoverOpen, preferPlace: 'above', body: callActionsBody, onOuterAction: handleClosePopover, bringToFront: true }, phoneAsTextOrButton)));
    };
    return PhoneNumberView;
}(React.PureComponent));
export { PhoneNumberView };
//# sourceMappingURL=phone-number-view.js.map